import React from 'react';
import styled from '@grebban/style-system-react';
import Link from 'Link';

/**
 *  Simple init of the core button component, needs to be made into typescript.
 */

const StyledButton = styled('button')``;

// @TODO Change "onclick" and "to" to "action" instead.
const Button = ({ children, disabled, name, onClick, to, type, value, rel, target, ...rest }) => {
    // If we don't have children then don't return anything cause there is nothing to show.
    if (!children) {
        return null;
    }

    // If "onClick" is defined and equal to a function then we return a button because that is what it is.
    if (typeof onClick === 'function' || typeof onClick?.[0] === 'function') {
        return (
            <StyledButton disabled={disabled} name={name} type={type} value={value} onClick={onClick} {...rest}>
                {children}
            </StyledButton>
        );
    }

    // If "to" is defined and equal to a string then we return a link because that is what it is.
    if (typeof to === 'string' || typeof to?.[0] === 'string') {
        return (
            <Link to={to} volatile={false} rel={rel} target={target} {...rest}>
                {children}
            </Link>
        );
    }

    // If nothing is defined then we return nothing.
    return null;
};

export default Button;
